/* @flow */
// first because it patches runtime env
import 'polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { Router, browserHistory } from 'react-router';
import Config from 'Config';
import { routeRenderer } from 'lib/Startup';
import * as zopim from 'lib/zopimListener';

import AppActions from 'actions/AppActions';
import { promiseDataIfSignedIn } from 'promises/userBootData';
import routes from './routes';
import store, { apolloClient } from './reduxStore';
import { registerInterceptor } from 'singletons/xhrInterceptors';
import { serviceUnavailableInterceptor } from 'lib/ResponseInterceptors';

import './styles/app.scss';

if (__DEV__) {
  require('utils/setupPerfUtils');
}

if (window.trackJs) {
  // https://trackjs.com/blog/unhandled-promises/
  window.addEventListener('unhandledrejection', function (event) {
    const info = ('reason' in event) ? event.reason : event;
    window.trackJs.track(info);
  });
}

zopim.listenForStatusChange(store.dispatch);

__webpack_public_path__ = Config.Environment.PUBLIC_PATH; // eslint-disable-line

registerInterceptor('503-interceptor', serviceUnavailableInterceptor);

promiseDataIfSignedIn().then(() => {
  AppActions.observeConnection();

  const container = document.getElementById('app');

  ReactDOM.render((
    <ApolloProvider store={store} client={apolloClient}>
      <Router
        routes={routes}
        history={browserHistory}
        render={routeRenderer}
      />
    </ApolloProvider>
  ), container);
})
.catch(error => {
  console.error('Application failed to load:', error.stack ? error.stack : error);
  // TODO: Pretty failure
  throw error;
});



// WEBPACK FOOTER //
// ./src/app.js